import React, { useCallback } from 'react';
import './style.scss';
import { Link } from 'react-router-dom'
import { images, scrollToTop, cardDataAiml, IMAGES } from 'src/shared/utils/appConstant';
import HomePageFooter from '../home/components/Footer';
import Footer from "src/components/footer";
import Cards from 'src/components/cards';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { pageRoutes } from 'src/shared/utils/pageRoutes.constant';



const AIML: React.FC = () => {
  const handleScrollToTop = useCallback(() => scrollToTop(), []);

  return (
    <>
      <div className='page-container-aiml'>
        <div className='image-container'>
          <div className="text-container">
            <h1 className='heading drop-in'>AI-Driven Solutions</h1>
            <p className='heading-desc display-none drop-in-2'>We deliver intelligent, future-ready AI and ML solutions that help enterprises innovate, scale efficiently, 
              and achieve measurable business impact through automation and data-driven transformation.</p>
          </div>
          <p className='breadcrumb position-abs drop-in-2'>
            <Link className='breadcrumb-link' to={pageRoutes?.Home} onClick={handleScrollToTop}>Home </Link>
            <span className="breadcrumb-separator"> / </span>
            <p className="">
              <Link className='breadcrumb-link' to={pageRoutes?.Services}>Services</Link>
            </p>
            <span className="breadcrumb-separator"> / </span>
            <p className="fw-light">
              <Link className='breadcrumb-link' to={pageRoutes?.AIML} onClick={handleScrollToTop}>AI-Driven Solutions</Link>
            </p>
          </p>
          <div className='red-bg-box'></div>
        </div>

        <div className="about-our-service">
          <div className="left-section animate__animated animate__fadeInLeft animate__delay-1s">
            <h5>About Our Service</h5>
            <h2>AI-Driven Solutions</h2>
            <p>At Wingman Partners, we help global enterprises harness the power of Artificial Intelligence to drive innovation, efficiency, and growth. Our AI solutions are tailored to meet the unique needs of clients across the USA, UAE, and Europe—ensuring compliance, scalability, and measurable impact.
              <img alt="blue-box" className='blue-box' src={images.dark_blue_box} />
              <img alt="red-box" className='red-box' src={images.red_box} />
              <div className='red-box-sq'></div>
            </p>
            <img alt="ble-box" src={images.blue_box} />
          </div>
          <div className="right-section animate__animated animate__fadeInRight animate__delay-1s">
            <LazyLoadImage
              src={IMAGES.AIML_WEB}
              alt='aiml'
            />
          </div>
          <img src={images.blue_box} alt="blue box" />
          <img src={images.circles} className='circles-DevOps' alt="circles" />
        </div>

        <div className="lower-div">
          <h2>What We Offer</h2>
          <Cards cardData={cardDataAiml || []} />

          <div className="why-choose-wingman">
            <h2>Why choose Wingman for AI ?</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <LazyLoadImage
                    src={IMAGES.GLOBAL_DELIVERY}
                    alt='Global Delivery Model'
                  />
                </div>
                <div className="feature-content">
                  <h3>Global Delivery Model:</h3>
                  <p>Offshore expertise with local market understanding.</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <LazyLoadImage
                    src={IMAGES.FAST_TIME}
                    alt='Faster Time-to-Value'
                  />
                </div>
                <div className="feature-content">
                  <h3>Faster Time-to-Value:</h3>
                  <p>Time-to-Value: Agile delivery with measurable ROI.</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <LazyLoadImage
                    src={IMAGES.COMPLIANCE_READY}
                    alt='Compliance-Ready'
                  />
                </div>
                <div className="feature-content">
                  <h3>Compliance-Ready:</h3>
                  <p>GDPR, HIPAA, and regional data privacy standards.</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <LazyLoadImage
                    src={IMAGES.CUSTOM_SOLUTIONS}
                    alt='Custom Solutions'
                  />
                </div>
                <div className="feature-content">
                  <h3>Custom Solutions:</h3>
                  <p>Tailored AI strategies for your business goals.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
        <HomePageFooter page="" />
        <Footer />
      </div>
    </>
  )
}

export default AIML